import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import tokens from '../styles/tokens';

const defaultSortModelChange = (model, details) => {

}

const DataDisplay = ({
  rows,
  columns,
  loading,
  handleCellClick,
  sortModel,
  onSortModelChange = () => {},
  sx = {},
  pageSize = 100,
  pageSizeOptions = [100, 200],
  rowHeight = 52,
  disableSorting = false,
  disableFilter = false,
  density = 'standard',
  height = 480,
  noRowsText = 'No data to display'
}) => {
  const NoRows = () => (
    <Box sx={{ py: 4 }}>
      <Typography variant="body1" sx={{ color: tokens.colors.textMuted }}>{noRowsText}</Typography>
    </Box>
  )
  const hasControlledSort = Array.isArray(sortModel);

  const gridProps = useMemo(() => ({
    onCellClick: handleCellClick,
    rows,
    columns,
    initialState: {
      pagination: {
        paginationModel: {
          pageSize: pageSize,
        },
      },
    },
    disableColumnSorting: disableSorting,
    disableColumnFilter: disableFilter,
    showCellVerticalBorder: true,
    pageSizeOptions,
    disableRowSelectionOnClick: true,
    loading,
    slotProps: {
      loadingOverlay: {
        variant: 'linear-progress',
        noRowsVariant: 'linear-progress',
      },
    },
    sx,
    rowHeight,
    density,
  }), [columns, density, disableFilter, disableSorting, handleCellClick, loading, pageSize, pageSizeOptions, rowHeight, rows, sx]);

  if (hasControlledSort) {
    gridProps.sortModel = sortModel;
    gridProps.onSortModelChange = onSortModelChange;
  }

  return (
    <Box sx={{ height: height }}>
    <DataGrid
      sortModel={hasControlledSort ? sortModel : undefined}
      onSortModelChange={hasControlledSort ? onSortModelChange : undefined}
      onCellClick={handleCellClick}
      rows={rows}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: pageSize,
          },
        },
      }}
      disableColumnSorting={disableSorting}
      disableColumnFilter={disableFilter}
      showCellVerticalBorder={true}
      pageSizeOptions={pageSizeOptions}
      disableRowSelectionOnClick
      loading={loading}
      slotProps={{
        loadingOverlay: {
          variant: 'linear-progress',
          noRowsVariant: 'linear-progress',
        },
      }}
      slots={{ noRowsOverlay: NoRows }}
      sx={{
        borderRadius: tokens.radius.sm,
        border: `1px solid ${tokens.colors.border}`,
        backgroundColor: tokens.colors.surface,
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: tokens.colors.headerBg,
          borderBottom: `1px solid ${tokens.colors.border}`,
          fontWeight: 700
        },
        '& .MuiDataGrid-cell': {
          borderColor: tokens.colors.cellBorder
        },
        ...sx
      }}
      rowHeight={rowHeight}
      density={density}
      {...gridProps}
    />
    </Box>
  );
}

export default DataDisplay;
